import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ArticleSection() {
  const { t } = useTranslation();

  return (
    <section id="article" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-500 to-primary-700 p-8 text-background-50 md:p-12">
        <div className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-background-50/10" />
        <div className="pointer-events-none absolute -bottom-16 right-24 h-40 w-40 rounded-full bg-background-50/10" />

        <div className="relative max-w-2xl">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/20 px-3 py-1 text-xs font-semibold">
            <i className="ri-article-line" />
            {t('homeArticle.read_time')}
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold md:text-3xl">{t('homeArticle.title')}</h2>
          <p className="mt-3 text-sm leading-relaxed text-background-50/90 md:text-base">
            {t('homeArticle.subtitle')}
          </p>
          <Link
            to="/usfans-spreadsheet-guide"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100 whitespace-nowrap cursor-pointer"
          >
            {t('homeArticle.cta')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}